.icon {
  /* Override input adornment properties */
  fill: var(--gray-300) !important;

  &.clear {
    cursor: pointer;
  }
}

.placeholder {
  width: 16px;
  height: 16px;
}
